/**
 * Controls whether an audience is shown modals that promote app download
 */ export var APP_MIGRATION_AVAILABLE = 'APP_MIGRATION_AVAILABLE';
